import React, { useState, useEffect } from "react";
import CandidateAdminModel from "../../../../models/admin/candidate/response/CandidateAdminModel";
import adminCandidateService from "../../../../services/admin/admin-candidate-service";
import toasterUtils from "../../../../utils/toaster-utils";
import CandidatePasswordGridComponent from "./CandidatePasswordGridComponent";
import CandidatePasswordRequestModel from "../../../../models/admin/candidate/request/CandidatePasswordRequestModel";
import modalUtils from "../../../../utils/modal-utils";
import IdNameModel from "../../../../models/common/IdNameModel";
import { RoleEnum } from "../../../../models/enums/RoleEnum";
import { FormControl, InputLabel, MenuItem, Select, TextField, Button, Autocomplete } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface CandidatePasswordProps {
    roleList: IdNameModel[];
};

const CandidatePasswordComponent = (props: CandidatePasswordProps) => {
    const [candidateList, setCandidateList] = useState<CandidateAdminModel[]>([]);
    const [refreshCandidate, setRefreshCandidate] = useState<number>(2);
    const [nameSearch, setNameSearch] = useState<string>("");
    const [emailIdSearch, setEmailIdSearch] = useState<string>("");
    const [roleSearch, setRoleSearch] = useState<number>(RoleEnum.Candidate);

    useEffect(() => {
        clearSearch();
    }, []);

    const getCandidates = (name: string, emailId: string) => {
        setRefreshCandidate(2);
        let input: CandidatePasswordRequestModel = {
            name: name,
            emailId: emailId,
            roleId: roleSearch === 0 ? RoleEnum.Candidate : roleSearch
        };
        modalUtils.showLoader();
        adminCandidateService.getCandidatePassword(input).then((res) => {
            modalUtils.closeModal();
            setCandidateList([]);
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCandidateList(res.items);
            setRefreshCandidate(refreshCandidate * 5);
        }).catch((error) => {
            setRefreshCandidate(refreshCandidate * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const clearSearch = () => {
        setCandidateList([]);
        setNameSearch("");
        setEmailIdSearch("");
        setRefreshCandidate(2);
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <FormControl fullWidth margin="none" size="small">
                            <Autocomplete options={props.roleList} value={props.roleList.find((x) => x.id === roleSearch) || null}
                                onChange={(_, newValue) => setRoleSearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField {...params} label="Role" size="small" margin="normal" fullWidth />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="col-md-3">
                        <TextField label="Name Like" size="small" margin="normal" fullWidth variant="outlined" onChange={(e) => setNameSearch(e.target.value)} placeholder="Name Like" autoComplete="off" />
                    </div>
                    <div className="col-md-3">
                        <TextField label="Email Id" size="small" margin="normal" fullWidth variant="outlined" onChange={(e) => setEmailIdSearch(e.target.value)} placeholder="Email Id" autoComplete="off" />
                    </div>
                    <div className="col-md-3">
                        <Button variant="contained" color="success" onClick={() => getCandidates(nameSearch, emailIdSearch)} startIcon={<SearchIcon />} sx={{ ml: 2, mt: 2 }}>
                            Search
                        </Button>
                        <Button variant="contained" color="warning" onClick={() => clearSearch()} startIcon={<ClearIcon />} sx={{ ml: 2, mt: 2 }}>
                            Clear
                        </Button>
                    </div>
                </div>
                {candidateList.length > 0 && refreshCandidate > 2 &&
                    <CandidatePasswordGridComponent
                        key={refreshCandidate}
                        candidateList={candidateList} />
                }
            </div>
        </div>
    );
};
export default CandidatePasswordComponent;